<p
  data-testing-id="recaptcha-v3-info"
  class="validation-message"
  [ishServerHtml]="
    'recaptcha.v3.info_text'
      | translate : { '0': 'https://policies.google.com/privacy', '1': 'https://policies.google.com/terms' }
  "
></p>
